import React from 'react';
import { useTranslation } from 'react-i18next';

import SlideDialogV from '../../components/common/SlideDialogV';

const DisabledPersonSlideUp = ({ isOpen = true, onClose, onClick }) => {
  const { t } = useTranslation('dependents');
  const dialogs = {
    title: t('slideDialog3.title'),
    description: t('slideDialog3.description'),
    buttons: [{ label: t('slideDialog3.button'), onClick: onClick }],
  };

  return <SlideDialogV isOpen={isOpen} onClose={onClose} {...dialogs} />;
};

export default DisabledPersonSlideUp;
